(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wg-virtual-try-on"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wg-virtual-try-on')) {
    customElements.define('wg-virtual-try-on', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.shopify-section');
        if (!this.scope) return;
        this.update = () => {
          const source = this.scope.querySelector('#rf-try-on-btn');
          this.hidden = !source || source.disabled;
        };
        this.activate = (event) => {
          if (!event.target.closest('.wg-vto__button')) return;
          const source = this.scope.querySelector('#rf-try-on-btn');
          if (source && !source.disabled) source.click();
          else this.update();
        };
        this.addEventListener('click', this.activate);
        this.observer = new MutationObserver(this.update);
        this.observer.observe(this.scope, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled']
        });
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('click', this.activate);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
